import { Translate } from '@chipinside/translate'
import { Stack } from '@mui/material'
import { styled } from '@mui/material/styles'

import { SelectionProps } from '#/components/FormCall/Inputs/InputImage/types'
import Colors from '#/styles/Colors'

const Title = styled('div', {
  shouldForwardProp: prop => prop !== 'disabled',
})<{ disabled?: boolean }>(({ disabled }) => ({
  color: disabled ? Colors.darkerGray : Colors.primary,
  fontWeight: 500,
  pointerEvents: 'none',
  textAlign: 'center',
}))

const SubTitle = styled('div')({
  color: Colors.darkerGray,
  fontSize: '12px',
  marginTop: 8,
  textAlign: 'center',
})

const Wrapper = styled(Stack)({
  alignItems: 'center',
  flex: 1,
  justifyContent: 'center',
  width: '100%',
})

export const Selection = ({ description, disabled, onClick }: SelectionProps) => (
  <Wrapper onClick={onClick}>
    <Title disabled={disabled}>{Translate({ messageKey: 'upload_image' })}</Title>
    {description && <SubTitle>{description}</SubTitle>}
  </Wrapper>
)
